// extracted by mini-css-extract-plugin
module.exports = {"col":"Table_col__160YU","checkboxCol":"Table_checkboxCol__rNBvl","emailCol":"Table_emailCol__30jhw","actionCol":"Table_actionCol__1-eIq"};